import React, { useEffect } from 'react'
import { createPortal } from 'react-dom'

type ModalProps = {
  openModal: boolean
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>
  mainMessage?: string
  subMessage?: string
  buttonLabel?: string
  cancelLabel?: string
  onClearCart?: (e?: any) => void
}

function ModalBlockAddToCart({
  openModal,
  setOpenModal,
  mainMessage,
  subMessage,
  buttonLabel,
  cancelLabel,
  onClearCart,
}: ModalProps) {
  useEffect(() => {
    if (typeof document === 'undefined' || !document?.body?.style) {
      return
    }

    if (openModal) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'unset'
    }

    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [openModal])

  if (!openModal) {
    return null
  }

  return createPortal(
    <div
      className="fixed w-screen h-screen inset-0 z-[10001] flex items-center justify-center bg-black bg-opacity-40"
      onClick={() => setOpenModal(false)}
      onKeyDown={(e) => e.key === 'Escape' && setOpenModal(false)}
      role="button"
      tabIndex={0}
      aria-label="Fechar modal"
    >
      <div
        className="bg-white rounded-2xl z-[10002] shadow-lg w-[340px] h-[412px] flex flex-col justify-between py-8 px-6"
        onClick={(e) => e.stopPropagation()}
        role="presentation"
      >
        {/* Mensagens principais */}
        <div>
          <div className="px-7">
            <p className="text-center text-[#101010] text-base font-medium leading-6 mb-4 mt-7">
              {mainMessage}
            </p>
            <p className="text-center text-[#101010] text-base font-medium leading-6 mb-8 mt-6">
              {subMessage}
            </p>
          </div>

          {/* Botão principal */}
          <button
            onClick={onClearCart}
            className="w-full border border-[#101010] bg-[#101010] text-white rounded-full py-3 text-base font-semibold mb-3 hover:bg-[#2C2C2C] transition"
          >
            {buttonLabel}
          </button>

          {/* Botão cancelar */}
          <button
            onClick={() => setOpenModal(false)}
            className="w-full border border-[#E1E0DF] text-[#101010] rounded-full py-3 text-base font-semibold mb-4 hover:bg-[#F8F8F8] transition"
          >
            {cancelLabel}
          </button>
        </div>
      </div>
    </div>,
    document.body
  )
}

export default ModalBlockAddToCart
